import React, { useState } from 'react';
import { Heart, MessageCircle, Star, BadgeCheck } from 'lucide-react';
import { testimonials } from '../mock';

const TestimonialCard = ({ t, index }) => {
  const [liked, setLiked] = useState(false);
  // Stable random-ish baseline so each card shows a different but consistent count
  const baseLikes = 8 + ((index * 7) % 23);
  const likeCount = liked ? baseLikes + 1 : baseLikes;

  const toggleLike = (e) => {
    e.preventDefault();
    setLiked((v) => !v);
  };

  return (
    <article
      className="reveal break-inside-avoid mb-4 sm:mb-5 bg-white rounded-2xl border border-[color:var(--brand-50)] p-5 hover:shadow-lg transition-shadow"
      style={{ transitionDelay: `${index * 40}ms` }}
    >
      <div className="flex items-start gap-3">
        <img
          src={t.avatar}
          alt={t.name}
          className="w-11 h-11 rounded-full object-cover ring-2 ring-[color:var(--brand-50)] flex-shrink-0"
          loading="lazy"
          onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(t.name)}&background=26BCC1&color=fff&size=120`; }}
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="font-semibold text-[color:var(--ink)] text-[14px] truncate">{t.name}</span>
            <BadgeCheck className="w-4 h-4 text-[color:var(--brand)] flex-shrink-0" />
          </div>
          <div className="text-[12px] text-[color:var(--muted)]">{t.handle}</div>
        </div>
      </div>

      <p className="text-[14px] sm:text-[15px] text-[color:var(--ink)] leading-relaxed mt-3">{t.text}</p>

      <div className="flex items-center justify-between mt-4 pt-3 border-t border-[color:var(--brand-50)]">
        <div className="flex items-center gap-0.5">
          {[...Array(t.rating)].map((_, j) => (
            <Star key={j} className="w-3.5 h-3.5 fill-[color:var(--brand)] text-[color:var(--brand)]" />
          ))}
        </div>
        <div className="flex items-center gap-3 text-[color:var(--muted)]">
          <button
            type="button"
            onClick={toggleLike}
            aria-pressed={liked}
            aria-label={liked ? 'Batal suka' : 'Suka'}
            className={`flex items-center gap-1 text-xs transition-all duration-200 active:scale-90 ${liked ? 'text-red-500' : 'hover:text-red-500'}`}
          >
            <Heart
              className={`w-3.5 h-3.5 transition-all duration-300 ${liked ? 'fill-red-500 scale-110' : ''}`}
            />
            <span className="font-semibold tabular-nums">{likeCount}</span>
            <span>{liked ? 'Disukai' : 'Suka'}</span>
          </button>
          <button
            type="button"
            className="flex items-center gap-1 text-xs hover:text-[color:var(--brand)] transition-colors"
            aria-label="Balas"
          >
            <MessageCircle className="w-3.5 h-3.5" /> Balas
          </button>
        </div>
      </div>
    </article>
  );
};

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-16 lg:py-24 section-soft">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-white text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3 border border-[color:var(--brand-50)]">Testimoni</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Mereka yang telah <span className="text-[color:var(--brand)]">mempercayakan kami</span>
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 sm:gap-5 [column-fill:_balance]">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} t={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
